<template>
    <div class="ui modal" id="photomodal" style="margin:auto;position:static">
      <i class="close icon" @click="closePhotoModal"></i>
      <div class="header">Take a photo</div>
      <div class="image content">
        <div class="ui medium image">
          <video id="myvideo" autoplay="true" muted playsinline="true" style="width:100%;aspect-ratio: 4;object-fit: cover;"></video>
        </div>
        <div class="description">
          <div class="ui header">How to take a photo</div>
          <p>
            Please move your camera to position the number plate to fit in the rectangle on the left side.<br>
            Hold camera still and hit the button below<br><br>When you're done, the system will try to recognise it right away when you are online.
          </p>
          <div style="text-align:center"><button class="ui circular huge primary icon button" id="camerabtn" @click="takePicture"><i class="camera icon"></i></button></div>
          <div class="ui error visibleif message" id="cameraerror">Unable to start video device</div>
        </div>
      </div>
      <div class="actions">
        <button class="ui black deny button" @click="closePhotoModal">
          Cancel
        </button>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'PlatecameraModal',
        data() {
            return {
                videos:null,
                video:null,
                cameraError:null
            }
        },
        methods: {
            stopCamera() {
                // console.log('this.videos',this.videos);
                if (this.videos) {
                    this.videos.getTracks().forEach( (track) => {
                        // console.log('stopping track', track);
                        track.stop();
                    });

                    // console.log('nulling videos',this.videos);
                    this.videos = null;
                    // console.log('nulling2videos',this.videos);
                }
            },
            closePhotoModal() {
                this.stopCamera();
                this.$emit('closed');
            },
            takePicture() {
                var canvas = document.createElement('canvas');
                const context = canvas.getContext("2d");
                canvas.width = this.video.videoWidth;
                canvas.height = this.video.videoWidth/4;

                context.drawImage(this.video, 0, (this.video.videoHeight - (this.video.videoWidth/4))/2, this.video.videoWidth, this.video.videoWidth/4, 0, 0, this.video.videoWidth, this.video.videoWidth/4);
                const data = canvas.toDataURL("image/jpeg");

                this.$emit('newPicture', data);
                this.closePhotoModal();
            },
            startCamera() {
                var thiz = this;
                navigator.mediaDevices.getUserMedia({
                    audio: false,
                    video: {
                        facingMode: "environment"
                    }
                }).then((s) => {
                    thiz.video = document.getElementById('myvideo');
                    try {
                        thiz.video.srcObject = s;
                        thiz.videos = s;
                        // console.log('this.videos',thiz.videos);
                    }
                    catch(e){
                        console.log(e);
                        this.$emit('error', e.toString());
                    }
                }).catch(err=>{
                    console.log('system error #165', err);
                    this.$emit('error', err.message);
                });
            },
            recognisePlate() {
                var i, foundone=false;
                var thiz = this;

                //console.log('recognisePlate');

                if (navigator.onLine) {
                    //console.log('recognisePlate online');
                    for (i=0; i<this.regs.length; i++) {
                        if (Object.hasOwn(this.regs[i], 'reg')) continue;

                        fetch(this.$host+'/recognise', {
                            method:'POST',
                            mode:'cors',
                            credentials:'include',
                            headers:{'Content-type':'application/json'},
                            body:JSON.stringify({img:this.regs[i].p, i:i, location:this.selectedlocation})
                        }).then(res=>res.json()).then(res=>{
                        if (res.error){
                            console.log('application error #274', res);
                        }
                        else {
                            if (res && res.res && res.res.results && res.res.results.length>0) {
                                thiz.regs[res.i].reg = res.res.results[0].plate.toUpperCase();
                            }
                            else {
                                thiz.regs[res.i].reg = '';
                                //document.querySelectorAll('#stocklist .card input')[res.i].setAttribute('placeholder','-- unable to recognise --')
                                //document.querySelectorAll('#stocklist .card button.circular')[res.i].className = 'ui right floated mini circular icon red button';
                                //document.querySelectorAll('#stocklist .card')[res.i].className = 'red card';
                            }
                        }

                            setTimeout(()=>{thiz.recognisePlate()},1250);
                        }).catch(err=>{
                            console.log('system error #273', err);
                            setTimeout(()=>{thiz.recognisePlate()},5000);
                        });
                        foundone=true;
                        break;
                    }

                    if (!foundone) {
                        setTimeout(()=>{thiz.recognisePlate()},500);
                    }
                    else {
                        //console.log('recognisePlate offline');
                        setTimeout(()=>{thiz.recognisePlate()},1000);
                    }
                }
            }
        },
        beforeUnmounted() {
            this.stopCamera();
        },
        mounted() {
            this.startCamera();
        }
    }
</script>
